import React from 'react';
import classNames from 'classnames';

function TenantFederation({
  onFederatedLoginClick,
  primaryBackground,
  className,
  buttonText,
  additionalClassName,
  provider,
}) {
  return (
    <button
      className={classNames('button--primary primary-filled', 'login-button', [
        additionalClassName,
        className,
      ])}
      type="submit"
      style={primaryBackground}
      onClick={() => {
        onFederatedLoginClick(provider);
      }}
    >
      {buttonText}
    </button>
  );
}

export default TenantFederation;
